const DEFAULT_WIDGET_LAYOUT: any = {
    gauge: {
        w: 15,
        h: 9,
    },
    common: {
        w: 20,
        h: 7,
    },
};

const ALARMS_COMMENTS_CATEGORIES = 'ALARMS';
const UPCOMING_COMMENTS_CATEGORIES = 'UPCOMING';

export { DEFAULT_WIDGET_LAYOUT, ALARMS_COMMENTS_CATEGORIES, UPCOMING_COMMENTS_CATEGORIES };
